<template>
  <div class="">
    <div class="menu-label">
      <h4>Menu</h4>
    </div>
    <div class="menu-ctr">
      <div
        class="menu-option"
        v-for="option in allAdminOptions"
        :key="option.id"
      >
        <router-link
          ref="rtrLink"
          :to="option.url"
          class="menu-link"
          is-active="is-active"
        >
          <span class="icon" :class="selectClass(option.name)"></span>
          <li class="nm-li">
            {{ option.name }}
          </li>
        </router-link>
      </div>
      <div class="menu-option">
        <a
        @click="logoutLocal()"
          ref="rtrLink"
          class="menu-link"
          is-active="is-active" style="cursor: pointer" 
        >
          <span class="icon"></span>
          <li class="nm-li">
            Logout
          </li>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions} from "vuex";

export default {
  name: "Menu",
  components: {},
  data() {
    return {
      build: this.getBuild,
    };
  },
  computed: mapGetters(["allAdminOptions"]),
  methods: {
    ...mapActions([
      'logout',
      'setLoggedOut'
    ]),
    logoutLocal(){
      this.setLoggedOut()
      this.logout()
      this.$router.push('/').catch(()=>{})
    },
    selectClass(name) {
      switch (name) {
        case "Profile":
          return "icon-user";
        case "All Parts":
          return "icon-add-to-list";
        case "Billing":
          return "icon-credit-card";
        case "My Builds":
          return "icon-shopping-cart";
        case "My Orders":
          return "icon-text-document";
        default:
      }
    },
  },
};
</script>

<style scoped>
li {
  list-style-type: none;
  display: inline;
}
.is-active li {
  color:  #1997c6 !important;
}
.container {
  height: 100% !important;
  overflow: hidden;
  margin-top: 8px;
  border-right: 1px solid #9198aa;
  color: rgb(178, 179, 180) !important;
}
.menu-ctr{
    margin-top: 15px;
}
.menu-label {
  border-bottom: 1px solid #434857;
  margin-bottom: 6px;
}
.menu-label h4 {
  font-size: 15pt;
  font-weight: normal;
  letter-spacing: 1px;
  color: #434857;
  text-transform: uppercase;
}
.menu-link {
  margin-top: 2px !important;
  color: #cfd2da;
  font-size: 12pt;
  font-weight: lighter !important;
}
.menu-link:hover {
  text-decoration: unset;
  color: unset;
  transform: scale(1.01);
}
.menu-option {
  margin-top: 4px !important;
  font-size: 14pt;
  font-weight: 200 !important;

}
.nm-li {
  font-size: 12pt;
  margin-left: 10px;
}
</style>